import 'slick-carousel'
import jQuery from 'jquery'

class Slick {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._changing = false
        this.options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: false,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null
        }, JSON.parse(this._elem.dataset.slick) || '{}')
        this._progressBar = this._elem.getAttribute('data-progress-bar') == null ? null : document.querySelector(this._elem.getAttribute('data-progress-bar'))

        this._initialized = false

        if (this._elem.classList.contains('slick-slides-dynamic')) {
            let breakpoint = this._elem.getAttribute('data-dynamic-breakpoint')
            let windowWidth = window.innerWidth

            if (!breakpoint || windowWidth > breakpoint) {
                this.options = this.dynamicSlidesMath(this.options)
            }
        }

        if (this.options.mobileOnly) {
            this.options.showBelow = 769
        }

        if (!this.options.dontInit) {
            this.init()
        }
    }

    onInit () {
    }

    filterSlides (filter, slick) {
        if (this._initialized) {
            slick.slickUnfilter()
            slick.slickFilter(filter)
        }
    }

    dynamicSlidesMath (options) {
        let dyanmicSelector = this._elem.getAttribute('data-slides-dynamic')
        let slidesToShow = 0
        let widthTotal = 280
        let sliderWidth = this._elem.offsetWidth

        if (dyanmicSelector) {
            let slides = this._elem.querySelectorAll(dyanmicSelector)

            for (let el of slides) {
                widthTotal = widthTotal + el.offsetWidth + 40
                if (widthTotal > sliderWidth) {
                    break
                }
                slidesToShow++
            }
        }
        options.slidesToShow = slidesToShow
        if (widthTotal < sliderWidth) {
            this.options.variableWidth = false
            this._elem.classList.add('slick-list--paddingless')
        }
        return options
    }

    init () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            return false
        }

        jQuery(this._elem).on('init', (e, slick) => {
            this._initialized = true
            this._elem.classList.add('show-slider')
            this._elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid) {
                if (!vid.classList.contains('non-autoplay')) {
                    vid.play()
                    vid.removeAttribute('poster')
                }
            }
            if (this._elem.classList.contains('responsive-slides')) {
                if (!this._changing) {
                    this._changing = true
                    this.updateBreakpoint(slick)
                }
            }
            // Remove more options on slider's videos
            let allVideos = this._elem.querySelectorAll('video')
            if (allVideos) {
                allVideos.forEach(function (el) {
                    el.setAttribute('disablepictureinpicture', '')
                    el.setAttribute('controlslist', 'nodownload')
                })
            }

            // Set progress bar width
            if (this._progressBar) {
                let slidesShown = window.innerWidth < 768 ? 1 : this.options.slidesToShow
                this._progressBar.style.width = `${(slidesShown / slick.$slides.length) * 100}%`
            }
        })

        if (this._elem.classList.contains('responsive-slides')) {
            jQuery(this._elem).on('breakpoint', (e, slick) => {
                if (!this._changing) {
                    this._changing = true
                    this.updateBreakpoint(slick)
                }
            })
        }

        jQuery(this._elem).not('.slick-initialized').slick(this.options)

        jQuery(this._elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                if (!vid.classList.contains('non-autoplay')) {
                    vid.pause()
                }
            }

            if (this._progressBar) {
                let slidesShown = window.innerWidth < 768 ? 1 : this.options.slidesToShow
                let left = (nextSlide / slick.$slides.length) * 100

                if (slick.$slides.length - nextSlide < slidesShown && parseInt(slidesShown) !== 1) {
                    left = 100 - ((slidesShown / slick.$slides.length) * 100)
                }
                this._progressBar.style.left = `${left}%`
            }
        })

        jQuery(this._elem).on('afterChange', (e, slick, curSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null

            if (vid) {
                if (!vid.classList.contains('non-autoplay')) {
                    vid.play()
                    vid.removeAttribute('poster')
                }
            }
        })
    }

    updateBreakpoint (slick) {
        // Responsive slides filtering
        let breakpoint = this._elem.getAttribute('data-responsive-breakpoint')
        if (breakpoint) {
            let breakpointInt = parseInt(breakpoint)
            if (slick.activeBreakpoint > breakpointInt || slick.activeBreakpoint == null) {
                this.filterSlides('.slide-desktop', slick)
            } else {
                this.filterSlides('.slide-mobile', slick)
            }
        }
        this._changing = false
    }
}

export default Slick



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slick.js